import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './Signout.module.scss';

type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
  logoutYes: () => void;
  cancelLogout: string;
};

const Signout = ({ panelClassName, panelHeaderClassName, logoutYes, cancelLogout }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <>
      <section className={panelClassName}>
        <div className={panelHeaderClassName}>
          <h2>{t('sign_out')}</h2>
        </div>
        <p className={styles.content}>{t('sign_out_content')}</p>
        <div className={styles.buttonBar}>
          <span>
            <Button onClick={logoutYes} size="exlarge" variant="signoutYes" label={t('yes')} />
          </span>
          <span>
            <Button to={cancelLogout} color="primary" size="exlarge" variant="signoutNo" label={t('no')} />
          </span>
        </div>
      </section>
    </>
  );
};

export default Signout;
